import React, { useState } from "react";
import DateDisplay from "../common/DateDisplay";
import {
  DropDownIcon,
  MediaIcon,
  MembersIcon,
  TeamSettingIcon,
} from "../common/Icon";
import {
  ModemsTabelData1,
  ModemsTabelData2,
  ModemsTabelData3,
  ModemsTabelData4,
  ModemsTabelData5,
  ModemsTabelData6,
  ModemsTabelRow,
  teamDropdownData,
} from "../common/Helper";
const TeamProgress = () => {
  // DROPDOWN
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState();

  const handleOptionClick = (data) => {
    setSelectedOption(data.teamName);
    setDropdownOpen(false);
  };
  return (
    <>
      <div className="flex flex-col xm:flex-row items-center justify-between mx-[11px] relative">
        <DateDisplay />
        <div className="flex justify-between items-center pt-2 xm:pt-0">
          <div
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex cursor-pointer items-center justify-between border border-primary rounded-[37px] py-[12px] px-2 sm:px-4 md:px-[14px]  overflow-hidden relative w-[200px] 3xl:w-[220px]">
            <MembersIcon />
            <p className="px-3 xm:px-1 sm:px-2 text-[10px] xs:text-xs 3xl:text-sm font-normal text-primary">
              Team : {selectedOption || "Trading-Secrets"}
            </p>
            <span
              className={`duration-200  ${dropdownOpen ? "rotate-180" : ""}`}>
              <span className=" block">
                <DropDownIcon />
              </span>
            </span>
          </div>
          {dropdownOpen && (
            <ul className="cursor-pointer  overflow-hidden absolute z-50 top-[100%] sm:top-[91%] 3xl:top-[100%] right-0 w-[200px] p-0 m-0  list-none bg-[#F7F6FF] shadow-[0px_5.86667px_17.6px_0px_rgba(0,_0,_0,_0.10)] rounded-md">
              <div className="overflow-y-auto h-[200px] overflow_x_scroll_style">
                {teamDropdownData.map((data, index) => (
                  <li
                    className="text-black text-xs 3xl:text-sm font-medium  hover:bg-[#EAEAFE] hover:text-black px-4 py-3 duration-200 mr-1"
                    key={index}
                    onClick={() => handleOptionClick(data)}>
                    {data.teamName}
                  </li>
                ))}
              </div>
            </ul>
          )}
          <div className="flex justify-between ">
            <div className="ml-3 xm:ml-3 3xl:ml-5 cursor-pointer w-[38px] h-[38px] bg-[#F2F2FE] hover:bg-primary rounded-full p-2 mediaIcon-btn duration-300">
              <MediaIcon />
            </div>
            <div className="ml-3 3xl:ml-5 cursor-pointer teamSettingIcon-btn duration-300">
              <TeamSettingIcon />
            </div>
          </div>
        </div>
      </div>
      <div
        onClick={() => setDropdownOpen(false)}
        className={`fixed inset-0 min-h-full w-full z-20  bg-black opacity-10 ${
          dropdownOpen ? "w-[100%] " : "hidden"
        }`}></div>
      <div className="md:px-[98px]  my-8 pb-2 xm:pb-0  mx-2 md:mx-0 ">
        <div className="flex justify-center pl-24 xs:pl-0 max-[430px]:max-w-[800px] w-auto max-w-full overflow-x-scroll md:overflow-x-hidden  overflow_x_scroll_style">
          <div className="flex flex-col items-center pb-2">
            <div className=" w-[49px] h-[135px] bg-[#FBFBFF] mt-3.5 flex items-end">
              <div className={`bg-graf w-[49px] h-[77px]`}></div>
            </div>
            <h5 className="font-semibold text-[12px] md:text-xs text-black pt-3 whitespace-nowrap">
              New Contact
            </h5>
            <p className="font-semibold text-[10px] text-black pt-1 whitespace-nowrap">
              25% Complete
            </p>
          </div>
          <div className="pl-2 md:pl-6 flex flex-col items-center">
            <div className=" w-[49px] h-[135px] bg-[#FBFBFF] mt-3.5 flex items-end">
              <div className={`bg-new_purpal w-[49px] h-[120px]`}></div>
            </div>
            <h5 className="font-semibold text-[12px] md:text-xs text-black pt-3 whitespace-nowrap">
              Scheduled Meeting
            </h5>
            <p className="font-semibold text-[10px] text-black pt-1 whitespace-nowrap">
              75% Complete
            </p>
          </div>
          <div className="pl-2 md:pl-6 flex flex-col items-center">
            <div className=" w-[49px] h-[135px] bg-[#FBFBFF] mt-3.5 flex items-end">
              <div
                className={`bg-[linear-gradient(90deg,_#16D9E3_0%,_#30C7EC_47%,_#46AEF7_100%)] w-[49px] h-[44px]`}></div>
            </div>
            <h5 className="font-semibold text-[12px] md:text-xs text-black pt-3 whitespace-nowrap">
              Scheduled Meeting
            </h5>
            <p className="font-semibold text-[10px] text-black pt-1 whitespace-nowrap">
              20% Complete
            </p>
          </div>
          <div className="pl-2 md:pl-6 flex flex-col items-center">
            <div className=" w-[49px] h-[135px] bg-[#FBFBFF] mt-3.5 flex items-end">
              <div
                className={`bg-[linear-gradient(153deg,_#63FF9D_-9.36%,_#7CD4FF_98.49%)] w-[49px] h-[22px]`}></div>
            </div>
            <h5 className="font-semibold text-[12px] md:text-xs text-black pt-3 whitespace-nowrap">
              Reconnect
            </h5>
            <p className="font-semibold text-[10px] text-black pt-1 whitespace-nowrap">
              10% Complete
            </p>
          </div>
        </div>
      </div>
      {/* =============================================== */}
      <div className="pb-5 px-2 w-auto max-w-[800px] md:w-full md:max-w-full overflow-x-scroll overflow_x_scroll_style ">
        <table className="mx-auto">
          <tr>
            <div className="bg-[#fbfbff] border-r-[#f2f2f2] border-r  rounded-t-md">
              {ModemsTabelRow.map((data) => {
                return (
                  <td
                    className={`3xl:px-4 py-[15px] 3xl:py-5 text-center ${data.headingRowStyle}`}>
                    <p
                      className={`font-semibold text-xs text-black mb-0 ${data.tabelRowStyle}`}>
                      {data.dataName}
                    </p>
                  </td>
                );
              })}
            </div>
          </tr>
          <div>
            <div className=" xl:h-[calc(100vh-585px)] 3xl:h-[calc(100vh-611px)] xl:overflow-y-auto overflow_x_scroll_style md:overflow-x-hidden ">
              <tr className=" border border-r-[#f2f2f2] border-[#f2f2f2]">
                <div className="bg-[#FFFFFF] flex items-center">
                  {ModemsTabelData1.map((data) => {
                    return (
                      <td
                        className={`3xl:px-4 py-[15px] 3xl:py-5 text-center ${data.headingRowStyle}`}>
                        <p
                          className={`text-black font-normal text-xs mb-0 ${data.tabelRowStyle}`}>
                          {data.dataName}
                        </p>
                      </td>
                    );
                  })}
                </div>
              </tr>
              <tr className=" border border-r-[#f2f2f2] border-[#f2f2f2] ">
                <div className="bg-[#FFFFFF] flex items-center">
                  {ModemsTabelData2.map((data) => {
                    return (
                      <td
                        className={`3xl:px-4 py-[15px] 3xl:py-5 text-center ${data.headingRowStyle}`}>
                        <p
                          className={`text-black font-normal text-xs  mb-0 ${data.tabelRowStyle}`}>
                          {data.dataName}
                        </p>
                      </td>
                    );
                  })}
                </div>
              </tr>
              <tr className=" border border-r-[#f2f2f2] border-[#f2f2f2] ">
                <div className="bg-[#FFFFFF] flex items-center">
                  {ModemsTabelData3.map((data) => {
                    return (
                      <td
                        className={`3xl:px-4 py-[15px] 3xl:py-5 text-center ${data.headingRowStyle}`}>
                        <p
                          className={`text-black font-normal text-xs  mb-0 ${data.tabelRowStyle}`}>
                          {data.dataName}
                        </p>
                      </td>
                    );
                  })}
                </div>
              </tr>
              <tr className=" border border-r-[#f2f2f2] border-[#f2f2f2] ">
                <div className="bg-[#FFFFFF] flex items-center">
                  {ModemsTabelData4.map((data) => {
                    return (
                      <td
                        className={`3xl:px-4 py-[15px] 3xl:py-5 text-center ${data.headingRowStyle}`}>
                        <p
                          className={`text-black font-normal text-xs  mb-0 ${data.tabelRowStyle}`}>
                          {data.dataName}
                        </p>
                      </td>
                    );
                  })}
                </div>
              </tr>
              <tr className=" border border-r-[#f2f2f2] border-[#f2f2f2] ">
                <div className="bg-[#FFFFFF] flex items-center">
                  {ModemsTabelData5.map((data) => {
                    return (
                      <td
                        className={`3xl:px-4 py-[15px] 3xl:py-5 text-center ${data.headingRowStyle}`}>
                        <p
                          className={`text-black font-normal text-xs  mb-0 ${data.tabelRowStyle}`}>
                          {data.dataName}
                        </p>
                      </td>
                    );
                  })}
                </div>
              </tr>
              <tr className="border border-r-[#f2f2f2] border-[#f2f2f2] border-t-0 border-b-0 border-l-transparent">
                <div className="bg-[#fbfbff] rounded-b-md flex items-center">
                  {ModemsTabelData6.map((data) => {
                    return (
                      <td
                        className={`3xl:px-4 py-[15px] 3xl:py-5 text-center ${data.headingRowStyle}`}>
                        <p
                          className={`text-black font-semibold text-xs mb-0 ${data.tabelRowStyle}`}>
                          {data.dataName}
                        </p>
                      </td>
                    );
                  })}
                </div>
              </tr>
            </div>
          </div>
        </table>
      </div>
    </>
  );
};

export default TeamProgress;
